import React, { useEffect, useState } from "react";
import { MemberSideBar, textTheme } from "@milestone/component-library";
import styled from "styled-components";
import { NestedRoutes } from "../../../app/routes.types";
import { useParams } from "react-router-dom";
import { useMemberDetails } from "../../../services/hooks/MemberDetails";
import { makeName } from "../../../services/hooks/MembersList";
import { useAppSelector } from "../../../store/hooks";

const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

const MemberContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const MemberContent = styled.div`
  align-self: center;
  height: 100%;
  padding: 22px 32px;
  min-width: 937px;
  display: flex;
  justify-content: center;
`;

const Name = styled.h3`
  ${textTheme.h3};
  margin: 0;
  margin-bottom: 21px;
`;

export const MemberLayout: React.FC<{
  links?: Array<NestedRoutes>;
}> = props => {
  const user = useAppSelector(state => state.auth.user);
  const [name, setName] = useState("");
  const { memberId } = useParams<{ memberId: string }>();
  const memberDetails = useMemberDetails(memberId);

  useEffect(() => {
    if (memberDetails) {
      setName(makeName(memberDetails.member));
    }
  }, [memberDetails]);

  return (
    <Container>
      <MemberContainer>
        <div>
          <Name>{name}</Name>
          <MemberSideBar
            links={props.links || []}
            userPermissions={user.permissions}
          />
        </div>
        <MemberContent>{props.children}</MemberContent>
      </MemberContainer>
    </Container>
  );
};
